"use client";
import React, { useState } from "react";
import { Box, Flex, Button } from "@chakra-ui/react";
import { LEARNING_LABS } from "@/app/pricing/learningLabsTable/constants";
import DataCenterTable from "app/pricing/learningLabsTable/dataCenter";
import EnterpriseTable from "app/pricing/learningLabsTable/enterprise";
import SecurityTable from "app/pricing/learningLabsTable/security";
import { SectionDivider } from "app/components/shared/SectionDivider";

const LearningLabTables = () => {
  const [selectedOption, setSelectedOption] = useState(LEARNING_LABS.dataCenter.id);
  const handleClick = (option) => {
    setSelectedOption(option);
  };

  return (
    <Box data-cy="section-learning-lab-pricing" id="section-pricing">
      <SectionDivider label={"Our Labs"} />
      <Flex
        direction={{ base: "column", md: "row" }}
        gap={"15px"}
        justifyContent={"center"}
      >
        <Button
          onClick={() => handleClick(LEARNING_LABS.dataCenter.id)}
          width={{ base: "100%", md: "30%" }}
          height={"55px"}
          fontSize={"18px"}
          color={selectedOption === LEARNING_LABS.dataCenter.id ? "black" : "white"}
          bgColor={
            selectedOption === LEARNING_LABS.dataCenter.id ? "#E2E8F0" : "blue.400"
          }
          _hover={{}}
        >
          {LEARNING_LABS.dataCenter.label}
        </Button>
        <Button
          onClick={() => handleClick(LEARNING_LABS.enterprise.id)}
          width={{ base: "100%", md: "30%" }}
          height={"55px"}
          fontSize={"18px"}
          color={selectedOption === LEARNING_LABS.enterprise.id ? "black" : "white"}
          bgColor={
            selectedOption === LEARNING_LABS.enterprise.id ? "#E2E8F0" : "blue.400"
          }
          _hover={{}}
        >
          {LEARNING_LABS.enterprise.label}
        </Button>
        <Button
          onClick={() => handleClick(LEARNING_LABS.security.id)}
          width={{ base: "100%", md: "30%" }}
          height={"55px"}
          fontSize={"18px"}
          color={selectedOption === LEARNING_LABS.security.id ? "black" : "white"}
          bgColor={selectedOption === LEARNING_LABS.security.id ? "#E2E8F0" : "blue.400"}
          _hover={{}}
        >
          {LEARNING_LABS.security.label}
        </Button>
      </Flex>
      {selectedOption === LEARNING_LABS.dataCenter.id && <DataCenterTable />}
      {selectedOption === LEARNING_LABS.enterprise.id && <EnterpriseTable />}
      {selectedOption === LEARNING_LABS.security.id && <SecurityTable />}
    </Box>
  );
};
export default LearningLabTables;
